// LEHUA PDP — Gallery, Accordion, Sticky Bar, Variants, Modal, CTAs
(function () {
  'use strict';

  // === Gallery: thumb click ↔ track scroll sync ===
  function initGallery() {
    document.querySelectorAll('.lehua-pdp-main__gallery').forEach(gallery => {
      const track = gallery.querySelector('.lehua-pdp-main__gallery-track');
      const slides = gallery.querySelectorAll('.lehua-pdp-main__gallery-slide');
      const thumbs = gallery.querySelectorAll('.lehua-pdp-main__gallery-thumb');
      const prevArrow = gallery.querySelector('.lehua-pdp-main__gallery-arrow--prev');
      const nextArrow = gallery.querySelector('.lehua-pdp-main__gallery-arrow--next');
      if (!track || !slides.length) return;

      // Só as fotos VISÍVEIS (o filtro por cor esconde as outras com display:none).
      const visibleSlides = () => Array.prototype.filter.call(slides, s => s.style.display !== 'none');

      const scrollToSlide = slide => {
        if (slide) track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
      };

      // Foto visível mais próxima do scroll atual → posição dentro do conjunto visível.
      const currentVisible = () => {
        const vis = visibleSlides();
        let index = 0, bestDist = Infinity;
        vis.forEach((s, i) => {
          const d = Math.abs(s.offsetLeft - track.scrollLeft);
          if (d < bestDist) { bestDist = d; index = i; }
        });
        return { vis: vis, index: index };
      };

      const syncUI = () => {
        const state = currentVisible();
        const current = state.vis[state.index];
        // thumb ativo pelo índice ORIGINAL da foto atual
        if (current) {
          const orig = parseInt(current.dataset.slide, 10);
          thumbs.forEach((t, i) => t.classList.toggle('is-active', i === orig));
        }
        // setas: some no extremo das fotos VISÍVEIS
        if (prevArrow) prevArrow.hidden = state.index <= 0;
        if (nextArrow) nextArrow.hidden = state.index >= state.vis.length - 1;
      };

      const step = dir => {
        const state = currentVisible();
        const target = Math.min(Math.max(state.index + dir, 0), state.vis.length - 1);
        scrollToSlide(state.vis[target]);
      };

      thumbs.forEach((thumb, i) => {
        thumb.addEventListener('click', e => {
          e.preventDefault();
          scrollToSlide(slides[i]);
        });
      });

      if (prevArrow) prevArrow.addEventListener('click', () => step(-1));
      if (nextArrow) nextArrow.addEventListener('click', () => step(1));

      // sync active thumb + setas on scroll/swipe (e quando o filtro de cor mexe o scroll)
      let scrollTimer;
      track.addEventListener('scroll', () => {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(syncUI, 60);
      }, { passive: true });

      syncUI();
    });
  }

  // === Accordion (info column) ===
  function initAccordion() {
    document.querySelectorAll('.lehua-pdp-main__accordion-item').forEach(item => {
      const header = item.querySelector('.lehua-pdp-main__accordion-header');
      if (!header) return;
      header.addEventListener('click', () => {
        const willOpen = !item.classList.contains('is-open');
        item.classList.toggle('is-open');
        header.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      });
    });
  }

  // === Sticky bottom bar (mobile) ===
  function initStickyBar() {
    const bar = document.querySelector('.lehua-pdp-main__sticky-bar');
    const hero = document.querySelector('.lehua-pdp-main__hero');
    if (!bar || !hero) return;
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          const visible = !entry.isIntersecting;
          bar.classList.toggle('is-visible', visible);
          bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
        });
      },
      { threshold: 0, rootMargin: '-200px 0px 0px 0px' }
    );
    observer.observe(hero);
  }

  // === Variant picker ===
  function initVariantPicker() {
    document.querySelectorAll('.lehua-pdp-main__form').forEach(form => {
      const variantsAttr = form.getAttribute('data-variants');
      if (!variantsAttr) return;
      let variants;
      try {
        variants = JSON.parse(variantsAttr);
      } catch (e) {
        console.warn('Lehua PDP: invalid variants JSON', e);
        return;
      }
      if (!Array.isArray(variants) || !variants.length) return;

      let inventory = {};
      try { inventory = JSON.parse(form.getAttribute('data-inventory') || '{}'); } catch (e) { inventory = {}; }
      const stockEl = document.querySelector('[data-lehua-stock]');

      const idInput = form.querySelector('input[name="id"]');
      const priceEl = document.querySelector('.lehua-pdp-main__price');
      const compareEl = document.querySelector('.lehua-pdp-main__compare');
      const pixEl = document.querySelector('.lehua-pdp-main__pix');
      const stickyPriceEl = document.querySelector('.lehua-pdp-main__sticky-price');

      const optionGroups = form.querySelectorAll('.lehua-pdp-main__option');
      const selected = {}; // optionN -> value

      // Initialize selected with currently is-selected button per group
      optionGroups.forEach((group, groupIndex) => {
        const groupBtns = group.querySelectorAll('[data-option-value]');
        if (!groupBtns.length) return;
        const optionKey = 'option' + (groupIndex + 1);
        const initialBtn = group.querySelector('.is-selected') || groupBtns[0];
        if (initialBtn) selected[optionKey] = initialBtn.dataset.optionValue;
      });

      function findMatchingVariant() {
        return variants.find(v =>
          (!selected.option1 || v.option1 === selected.option1) &&
          (!selected.option2 || v.option2 === selected.option2) &&
          (!selected.option3 || v.option3 === selected.option3)
        );
      }

      function formatMoney(cents) {
        const value = (cents / 100).toFixed(2).replace('.', ',');
        return 'R$ ' + value;
      }

      function updateStickyThumb(color) {
        const stickyThumb = document.querySelector('[data-sticky-thumb]');
        if (!stickyThumb) return;
        const c = (color || '').toLowerCase().trim();
        const slides = document.querySelectorAll('.lehua-pdp-main__gallery-slide');
        let match = null, first = null;
        slides.forEach(s => {
          if (!first) first = s;
          if ((s.dataset.imgColor || '').toLowerCase().trim() === c) match = s;
        });
        const target = match || first; // fallback: foto principal (nunca foto velha)
        if (target && target.src) stickyThumb.src = target.src;
      }

      function updateUI(variant) {
        if (!variant) return;
        if (idInput) idInput.value = variant.id;
        // Estoque acabando: só mostra se a variante selecionada tem 1-4 unidades
        if (stockEl) {
          const _n = inventory[variant.id];
          if (_n && _n > 0 && _n < 5) {
            stockEl.textContent = 'Estoque acabando: ' + _n + (_n === 1 ? ' unidade' : ' unidades') + ' em ' + (variant.title || '');
            stockEl.hidden = false;
          } else {
            stockEl.hidden = true;
          }
        }
        if (priceEl) priceEl.textContent = formatMoney(variant.price);
        if (compareEl) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            compareEl.textContent = formatMoney(variant.compare_at_price);
            compareEl.style.display = '';
          } else {
            compareEl.style.display = 'none';
          }
        }
        let pct = 5;
        if (pixEl) {
          const pixMatch = pixEl.textContent.match(/(\d+)%/);
          pct = pixMatch ? parseInt(pixMatch[1], 10) : 5;
          const pixPrice = Math.round(variant.price * (100 - pct) / 100);
          pixEl.textContent = formatMoney(pixPrice) + ' no Pix · ' + pct + '% off';
        }
        if (stickyPriceEl) {
          if (pixEl) {
            const pixPrice = Math.round(variant.price * (100 - pct) / 100);
            stickyPriceEl.textContent = formatMoney(pixPrice) + ' Pix';
          } else {
            stickyPriceEl.textContent = formatMoney(variant.price);
          }
        }
      }

      const stickySizes = document.querySelectorAll('.lehua-pdp-main__sticky-size');

      function syncStickySizes(value) {
        stickySizes.forEach(s => {
          const selected = s.dataset.stickySize === value;
          s.classList.toggle('is-selected', selected);
          s.setAttribute('aria-checked', selected ? 'true' : 'false');
        });
      }

      optionGroups.forEach((group, groupIndex) => {
        const optionKey = 'option' + (groupIndex + 1);
        const isSizeGroup = group.querySelector('.lehua-pdp-main__sizes') !== null;
        const isColorGroup = group.querySelector('.lehua-pdp-main__swatches') !== null;
        group.querySelectorAll('[data-option-value]').forEach(btn => {
          btn.addEventListener('click', e => {
            e.preventDefault();
            const value = btn.dataset.optionValue;
            selected[optionKey] = value;
            // Update visual state within this group
            group.querySelectorAll('[data-option-value]').forEach(b => {
              b.classList.remove('is-selected');
              b.setAttribute('aria-checked', 'false');
            });
            btn.classList.add('is-selected');
            btn.setAttribute('aria-checked', 'true');
            // Update label "Cor: <strong>X</strong>" if exists
            const labelEl = group.querySelector('.lehua-pdp-main__option-label strong');
            if (labelEl) labelEl.textContent = value;
            // Sync sticky sizes
            if (isSizeGroup) syncStickySizes(value);
            // Nome da cor + miniatura no sticky bar (miniatura via alt da foto)
            if (isColorGroup) {
              const stickyColor = document.querySelector('[data-sticky-color]');
              if (stickyColor) stickyColor.textContent = 'Cor: ' + value;
              updateStickyThumb(value);
            }
            // Find matching variant + update UI
            const variant = findMatchingVariant();
            updateUI(variant);
          });
        });
      });

      // Estado inicial: miniatura do sticky pela cor selecionada (via alt da foto)
      const _initSwatch = document.querySelector('.lehua-pdp-main__swatch.is-selected') || document.querySelector('.lehua-pdp-main__swatch');
      if (_initSwatch) updateStickyThumb(_initSwatch.dataset.optionValue);
      updateUI(findMatchingVariant());

      // Sticky size pills: click delega pro botão de tamanho do form principal
      stickySizes.forEach(pill => {
        pill.addEventListener('click', e => {
          e.preventDefault();
          if (pill.classList.contains('is-disabled')) return;
          const value = pill.dataset.stickySize;
          const target = form.querySelector('.lehua-pdp-main__size[data-option-value="' + CSS.escape(value) + '"]');
          if (target) target.click();
        });
      });
    });
  }

  // === Size guide modal ===
  function initSizeGuide() {
    const dialog = document.getElementById('lehua-size-guide-modal');
    if (!dialog) return;
    document.querySelectorAll('.lehua-pdp-main__size-guide-trigger').forEach(trigger => {
      trigger.addEventListener('click', e => {
        e.preventDefault();
        if (typeof dialog.showModal === 'function') {
          dialog.showModal();
        } else {
          dialog.setAttribute('open', '');
        }
      });
    });
    const closeBtn = dialog.querySelector('.lehua-pdp-main__size-guide-close');
    if (closeBtn) {
      closeBtn.addEventListener('click', () => dialog.close());
    }
    // Close on backdrop click
    dialog.addEventListener('click', e => {
      if (e.target === dialog) dialog.close();
    });
  }

  // === Add to cart via fetch + open cart drawer ===
  async function addToCartFromForm(form) {
    const submitBtn = form.querySelector('button[type="submit"][name="add"]');
    const originalText = submitBtn ? submitBtn.textContent : null;
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.textContent = 'Adicionando...';
    }
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        body: new FormData(form),
        headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' }
      });
      if (!res.ok) throw new Error('add failed: ' + res.status);
      // Refresh cart for accurate count
      const cart = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(r => r.json()).catch(() => ({}));
      // Dispatch cart:update so cart-drawer-component reacts
      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: { resource: cart, sourceId: 'lehua-pdp', data: { source: 'lehua-pdp', itemCount: cart.item_count } }
      }));
      // Open cart drawer if present
      const drawer = document.querySelector('cart-drawer-component');
      if (drawer && typeof drawer.open === 'function') {
        drawer.open();
      }
    } catch (err) {
      console.warn('Lehua PDP: add to cart failed, falling back to native submit', err);
      form.submit();
      return;
    } finally {
      if (submitBtn && originalText !== null) {
        submitBtn.disabled = false;
        submitBtn.textContent = originalText;
      }
    }
  }

  function initAddToCart() {
    document.querySelectorAll('.lehua-pdp-main__form form').forEach(form => {
      form.addEventListener('submit', e => {
        e.preventDefault();
        addToCartFromForm(form);
      });
    });
  }

  // === Sticky bar add-to-cart — submit main form via fetch ===
  function initStickyAdd() {
    document.querySelectorAll('[data-sticky-add]').forEach(btn => {
      btn.addEventListener('click', e => {
        e.preventDefault();
        const form = document.querySelector('.lehua-pdp-main__form form');
        if (!form) return;
        addToCartFromForm(form);
      });
    });
  }

  // === Coupon copy to clipboard ===
  function initCouponCopy() {
    document.querySelectorAll('[data-coupon-copy]').forEach(btn => {
      btn.addEventListener('click', async () => {
        const code = btn.dataset.couponCopy;
        if (!code) return;
        const labelEl = btn.querySelector('span') || btn;
        const originalLabel = labelEl.textContent;
        try {
          await navigator.clipboard.writeText(code);
        } catch (err) {
          // Fallback for old browsers
          const ta = document.createElement('textarea');
          ta.value = code;
          ta.style.position = 'fixed';
          ta.style.opacity = '0';
          document.body.appendChild(ta);
          ta.select();
          try { document.execCommand('copy'); } catch (e) { /* noop */ }
          document.body.removeChild(ta);
        }
        btn.classList.add('is-copied');
        labelEl.textContent = 'Copiado!';
        setTimeout(() => {
          btn.classList.remove('is-copied');
          labelEl.textContent = originalLabel;
        }, 2000);
      });
    });
  }

  // === Cross-sell automático: fetch Shopify recommendations + render ===
  function initRecommendations() {
    const container = document.querySelector('[data-lehua-recommendations]');
    if (!container) return;
    const productId = container.dataset.productId;
    const limit = container.dataset.limit || 8;
    const grid = container.querySelector('[data-lehua-recommendations-grid]');
    if (!productId || !grid) return;

    const url = '/recommendations/products?section_id=lehua-pdp-cross-sell&product_id=' + productId + '&limit=' + limit + '&intent=related';
    fetch(url, { headers: { 'Accept': 'text/html' } })
      .then(r => r.ok ? r.text() : null)
      .then(html => {
        if (!html) return;
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newGrid = doc.querySelector('[data-lehua-recommendations-grid]');
        if (newGrid && newGrid.children.length) {
          grid.innerHTML = newGrid.innerHTML;
        } else {
          // Fallback: try Shopify's product-recommendations endpoint
          fetch('/recommendations/products.json?product_id=' + productId + '&limit=' + limit + '&intent=related')
            .then(r => r.ok ? r.json() : null)
            .then(data => {
              if (!data || !data.products || !data.products.length) {
                container.style.display = 'none';
                return;
              }
              grid.innerHTML = data.products.map(p => {
                const img = p.featured_image || (p.images && p.images[0]) || '';
                const imgSrc = typeof img === 'string' ? img : (img && img.src) || '';
                const price = (p.price / 100).toFixed(2).replace('.', ',');
                return '<a class="lehua-pdp-cross-sell__card" href="' + p.url + '" aria-label="' + p.title.replace(/"/g, '&quot;') + '">' +
                  '<div class="lehua-pdp-cross-sell__media">' +
                    (imgSrc ? '<img src="' + imgSrc + '" alt="' + p.title.replace(/"/g, '&quot;') + '" loading="lazy" width="800" height="1000">' : '') +
                  '</div>' +
                  '<div class="lehua-pdp-cross-sell__name">' + p.title + '</div>' +
                  '<div class="lehua-pdp-cross-sell__price">R$ ' + price + '</div>' +
                '</a>';
              }).join('');
            })
            .catch(() => { container.style.display = 'none'; });
        }
      })
      .catch(() => { container.style.display = 'none'; });
  }

  // === Reviews mini badge → smooth scroll pra section reviews ===
  function initReviewsJump() {
    document.querySelectorAll('[data-lehua-reviews-jump]').forEach(link => {
      link.addEventListener('click', e => {
        e.preventDefault();
        const target = document.getElementById('lehua-reviews-anchor');
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  // Revela o badge de estrelas no topo SÓ quando há avaliação real (Judge.me populou).
  // Sem avaliação => fica oculto (sobe cor/tamanho, sem prova social negativa).
  function initReviewsBadge() {
    const mini = document.querySelector('.lehua-pdp-main__reviews-mini[data-lehua-reviews-jump]');
    if (!mini) return;
    const badge = mini.querySelector('.jdgm-preview-badge');
    if (!badge) return;

    const hasReviews = () => {
      const inner = badge.querySelector('.jdgm-prev-badge');
      if (!inner) return false;
      const n = parseInt(inner.getAttribute('data-number-of-reviews') || '0', 10);
      return n > 0;
    };

    const reveal = () => { if (hasReviews()) { mini.hidden = false; return true; } return false; };

    if (reveal()) return;
    // Judge.me carrega assíncrono: observa o badge e tenta por alguns segundos.
    let tries = 0;
    const obs = new MutationObserver(() => { if (reveal()) obs.disconnect(); });
    obs.observe(badge, { childList: true, subtree: true, attributes: true });
    const poll = setInterval(() => {
      tries++;
      if (reveal() || tries > 20) { clearInterval(poll); obs.disconnect(); }
    }, 500);
  }

  // === Disponibilidade: esconde cores esgotadas, risca tamanhos sem estoque ===
  function initVariantAvailability() {
    document.querySelectorAll('.lehua-pdp-main__form').forEach(form => {
      const variantsAttr = form.getAttribute('data-variants');
      if (!variantsAttr) return;
      let variants;
      try {
        variants = JSON.parse(variantsAttr);
      } catch (e) {
        return;
      }
      if (!Array.isArray(variants) || !variants.length) return;

      const swatchGroup = form.querySelector('.lehua-pdp-main__swatches');
      const sizeGroup = form.querySelector('.lehua-pdp-main__sizes');

      // Valores de opção de uma variante (ignora nulos), independente da ordem cor/tamanho
      const optsOf = v => [v.option1, v.option2, v.option3].filter(o => o != null);
      // Cor disponível = existe ALGUMA variante disponível com essa cor
      const colorAvailable = color =>
        variants.some(v => v.available && optsOf(v).indexOf(color) !== -1);
      // Combinação cor+tamanho disponível?
      const comboAvailable = (color, size) =>
        variants.some(v => v.available && optsOf(v).indexOf(color) !== -1 && optsOf(v).indexOf(size) !== -1);

      // 1) Esconde cores 100% esgotadas
      if (swatchGroup) {
        swatchGroup.querySelectorAll('[data-option-value]').forEach(btn => {
          btn.classList.toggle('is-hidden', !colorAvailable(btn.dataset.optionValue));
        });
      }

      // 2) Risca tamanhos indisponíveis para a cor selecionada
      function updateSizesFor(color) {
        if (!sizeGroup) return;
        sizeGroup.querySelectorAll('[data-option-value]').forEach(btn => {
          const size = btn.dataset.optionValue;
          const ok = color
            ? comboAvailable(color, size)
            : variants.some(v => v.available && optsOf(v).indexOf(size) !== -1);
          btn.classList.toggle('is-unavailable', !ok);
        });
        // Se o tamanho selecionado ficou indisponível nessa cor, pula pro primeiro disponível
        const selectedSize = sizeGroup.querySelector('.is-selected');
        if (selectedSize && selectedSize.classList.contains('is-unavailable')) {
          const firstOk = sizeGroup.querySelector('[data-option-value]:not(.is-unavailable)');
          if (firstOk) firstOk.click();
        }
      }

      // Cor inicial (a selecionada, ou a primeira visível)
      let initialColor = null;
      if (swatchGroup) {
        const sel = swatchGroup.querySelector('.is-selected:not(.is-hidden)') ||
          swatchGroup.querySelector('[data-option-value]:not(.is-hidden)');
        initialColor = sel ? sel.dataset.optionValue : null;
      }
      updateSizesFor(initialColor);

      // Recalcula ao trocar de cor
      if (swatchGroup) {
        swatchGroup.querySelectorAll('[data-option-value]').forEach(btn => {
          btn.addEventListener('click', () => updateSizesFor(btn.dataset.optionValue));
        });
      }
    });
  }

  // === Associação cor → foto: bolinha mostra a foto da cor; clicar troca a galeria ===
  function initColorMedia() {
    document.querySelectorAll('.lehua-pdp-main__form').forEach(form => {
      const variantsAttr = form.getAttribute('data-variants');
      if (!variantsAttr) return;
      let variants;
      try {
        variants = JSON.parse(variantsAttr);
      } catch (e) {
        return;
      }
      if (!Array.isArray(variants) || !variants.length) return;

      const swatchGroup = form.querySelector('.lehua-pdp-main__swatches');
      if (!swatchGroup) return;

      const gallery = document.querySelector('.lehua-pdp-main__gallery');
      const track = gallery && gallery.querySelector('.lehua-pdp-main__gallery-track');
      const slides = gallery ? gallery.querySelectorAll('.lehua-pdp-main__gallery-slide') : [];
      const thumbs = gallery ? gallery.querySelectorAll('.lehua-pdp-main__gallery-thumb') : [];

      const optsOf = v => [v.option1, v.option2, v.option3].filter(o => o != null);
      // Primeira variante daquela cor que tenha foto associada
      function imageForColor(color) {
        const v = variants.find(x => optsOf(x).indexOf(color) !== -1 && x.featured_image && x.featured_image.src);
        return v ? v.featured_image : null;
      }

      // 1) Bolinha mostra a foto real da cor (quando a cor tem foto associada)
      swatchGroup.querySelectorAll('[data-option-value]').forEach(btn => {
        const img = imageForColor(btn.dataset.optionValue);
        const colorSpan = btn.querySelector('.lehua-pdp-main__swatch-color');
        if (img && colorSpan) {
          colorSpan.style.backgroundImage = 'url(' + img.src + ')';
          colorSpan.style.backgroundSize = 'cover';
          colorSpan.style.backgroundPosition = 'center';
        }
      });

      // 2) Clicar na cor leva a galeria pra foto daquela cor
      function showImage(img) {
        if (!img || !track || !slides.length) return;
        let target = null;
        slides.forEach(s => {
          if (String(s.dataset.imageId) === String(img.id)) target = s;
        });
        if (!target) return;
        track.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
        const idx = parseInt(target.dataset.slide, 10);
        if (!isNaN(idx)) thumbs.forEach((t, i) => t.classList.toggle('is-active', i === idx));
      }

      swatchGroup.querySelectorAll('[data-option-value]').forEach(btn => {
        btn.addEventListener('click', () => {
          const img = imageForColor(btn.dataset.optionValue);
          if (img) showImage(img);
        });
      });
    });
  }

  // === Galeria por cor: mostra só as fotos cujo alt = cor selecionada ===
  function initColorGallery() {
    document.querySelectorAll('.lehua-pdp-main__form').forEach(form => {
      const swatchGroup = form.querySelector('.lehua-pdp-main__swatches');
      if (!swatchGroup) return;
      const gallery = document.querySelector('.lehua-pdp-main__gallery');
      if (!gallery) return;
      const track = gallery.querySelector('.lehua-pdp-main__gallery-track');
      const slides = Array.prototype.slice.call(gallery.querySelectorAll('.lehua-pdp-main__gallery-slide'));
      const thumbs = Array.prototype.slice.call(gallery.querySelectorAll('.lehua-pdp-main__gallery-thumb'));
      if (slides.length < 2) return;

      const norm = s => (s || '').toLowerCase().trim();

      function filterByColor(color) {
        const c = norm(color);
        // Se nenhuma foto tem o alt dessa cor, mostra todas (fallback, nunca vazio)
        const hasMatch = slides.some(sl => norm(sl.dataset.imgColor) === c);
        slides.forEach(sl => {
          // vídeo (data-always-visible) nunca é escondido pelo filtro de cor
          const always = sl.hasAttribute('data-always-visible');
          sl.style.display = (always || !hasMatch || norm(sl.dataset.imgColor) === c) ? '' : 'none';
        });
        thumbs.forEach(th => {
          const always = th.hasAttribute('data-always-visible');
          th.style.display = (always || !hasMatch || norm(th.dataset.imgColor) === c) ? '' : 'none';
        });
        const firstVisible = slides.filter(sl => sl.style.display !== 'none')[0];
        if (firstVisible && track) {
          track.scrollLeft = firstVisible.offsetLeft;
          // avisa a galeria (setas/thumbs) que o conjunto visível mudou
          track.dispatchEvent(new Event('scroll'));
        }
      }

      const active = swatchGroup.querySelector('.lehua-pdp-main__swatch.is-selected') ||
        swatchGroup.querySelector('[data-option-value]');
      if (active) filterByColor(active.dataset.optionValue);

      swatchGroup.querySelectorAll('[data-option-value]').forEach(btn => {
        btn.addEventListener('click', () => filterByColor(btn.dataset.optionValue));
      });
    });
  }

  function init() {
    initGallery();
    initAccordion();
    initStickyBar();
    initVariantPicker();
    initVariantAvailability();
    initColorMedia();
    initColorGallery();
    initSizeGuide();
    initAddToCart();
    initStickyAdd();
    initCouponCopy();
    initReviewsJump();
    initReviewsBadge();
    initRecommendations();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
